import apiClient from '@/shared/api/client'
import type { Plant } from '@/shared/types/master'

interface ListParams {
  page?: number
  page_size?: number
  company_id?: string
  is_active?: boolean
}

interface PaginatedResponse<T> {
  items: T[]
  total: number
  page: number
  page_size: number
}

export const plantsApi = {
  list: async (params?: ListParams): Promise<PaginatedResponse<Plant>> => {
    const res = await apiClient.get<PaginatedResponse<Plant>>('/masters/plants', { params })
    return res.data
  },

  get: async (id: string): Promise<Plant> => {
    const res = await apiClient.get<Plant>(`/masters/plants/${id}`)
    return res.data
  },

  create: async (data: Omit<Plant, 'id' | 'company_name'>): Promise<Plant> => {
    const res = await apiClient.post<Plant>('/masters/plants', data)
    return res.data
  },

  update: async (id: string, data: Partial<Plant>): Promise<Plant> => {
    const res = await apiClient.patch<Plant>(`/masters/plants/${id}`, data)
    return res.data
  },
}
